<ngx-spinner template="<img src='assets/images/spinner.gif'/>"></ngx-spinner>
<div class="order-processing-content" dir="{{languageDir}}">
  <div class="content-top-box ">
    <ul class="breadcrumb">
      <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
        <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
          (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
      </li>
    </ul>
    <div class="top-box-content">
      <h1 class="main-title">{{langObj ? langObj?.InputReport  : ('Input Report' | translate)}}</h1>
    </div>
  </div>

  <form [formGroup]="InputForm">
    <div class="wrapper-box wrapper-box-shadow table-wrapper">
      <!-- <div class="content-top-box-content">
        <h1 class="content-title">Process Order</h1>
      </div> -->
      <div class="content-top-row content-top-row-order-processing" *ngIf="Isexpandcontenthide">
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="queryCriteria" (selectionChange)="criteriaChange($event)"
            placeholder="{{langObj ? langObj?.QueryCriteria  : ('Query Criteria' | translate)}}" panelClass="testClass" name="Status">
            <mat-option value="lastshift">Last Shift</mat-option>
            <mat-option value="yesterday">Yesterday</mat-option>
            <mat-option value="today" selected>Today</mat-option>
            <mat-option value="custom">Custom</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="inputField">
          <nz-date-picker  class="calender-input" [nzDisabled]="disabled" id="startPicker" formControlName="startDate" nzFormat="dd/MM/yyyy HH:mm"
          [nzShowTime]="{ nzFormat: 'HH:mm' }"  [nzInputReadOnly]="true" (ngModelChange)="getProcessOrder()"></nz-date-picker>
          <span class="floating-text">{{langObj ? langObj?.StartDate  : ('Start Date' | translate)}}</span>   
        </div>
        <div class="inputField">
          <nz-date-picker  class="calender-input" [nzDisabled]="disabled"  id="endPicker" formControlName="endDate" nzFormat="dd/MM/yyyy HH:mm"
          [nzShowTime]="{ nzFormat: 'HH:mm' }"  [nzInputReadOnly]="true" (ngModelChange)="getProcessOrder()" ></nz-date-picker>
          <span class="floating-text">{{langObj ? langObj?.EndDate  : ('End Date' | translate)}}</span>   
        </div>
        <!-- GROUP -->
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing" >
          <mat-select formControlName="UserGroup1" (selectionChange)="getPlants($event)" placeholder="{{langObj ? langObj?.Group  : ('Group' | translate)}}"
            panelClass="testClass" name="Status">
            <mat-option *ngFor="let group of GroupList" [value]="group.EG_Id">
              {{group.EG_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing" >
          <mat-select formControlName="UserPlant1" placeholder="{{langObj ? langObj?.Plant  : ('Plant' | translate)}}" panelClass="testClass" name="plant" (selectionChange)="getProcessOrder()">
            <mat-option *ngFor="let plant of PlantList1" [value]="plant.PT_Id">
              {{plant.PT_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- <mat-form-field appearence="fill"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                <mat-select formControlName="shift"  placeholder="Shift" 
                    panelClass="testClass" name="Status">
                    <mat-option  value="all">ALL</mat-option>
                    <mat-option  value="day">Day</mat-option>
                    <mat-option  value="night">Night</mat-option>
                </mat-select>
            </mat-form-field> -->

      </div>
      <div class="content-top-row content-top-row-order-processing" *ngIf="Isexpandcontenthide">
        <!-- <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="line" placeholder="Line" panelClass="testClass" name="line">
            <mat-option *ngFor="let line of lineList" [value]="line.PL_Id">
              {{line.PL_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="unit" placeholder="Unit" panelClass="testClass" name="unit">
            <mat-option *ngFor="let unit of unitList" [value]="unit.PU_Id">
              {{unit.PU_Desc}}
            </mat-option>
          </mat-select>
        </mat-form-field> -->
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="po" placeholder="{{langObj ? langObj?.ProcessOrder  : ('Process Order' | translate)}}" (selectionChange)="onPOChange($event)"
            panelClass="testClass" name="po">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'TypeName'" [array]="processOrderList"
            (filteredReturn)="filteredPOs = $event"></mat-select-filter>
            <mat-option *ngFor="let po of filteredPOs" [value]="po.TypeId">
              {{po.TypeName}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-select formControlName="ItemCode" (selectionChange)="onItemCodeChange($event)" placeholder="{{langObj ? langObj?.ItemDesc  : ('Item Desc' | translate)}}"
              panelClass="testClass" name="itemCode">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'ItemDesc'" [array]="itemList"
              (filteredReturn)="filteredItemCodes = $event"></mat-select-filter>
              <mat-option *ngFor="let item of filteredItemCodes" [value]="item.ItemCode" matTooltipClass="custom-tooltip" matTooltip="{{item.ItemCode}}" matTooltipposition="right">
                {{item.ItemDesc}}
              </mat-option>
            </mat-select>
          </mat-form-field>

        <!-- <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
          <mat-select formControlName="batchType" placeholder="Batch Type" panelClass="testClass" name="Status">
            <mat-option value="0">ALL</mat-option>
            <mat-option value="1">Rework</mat-option>
            <mat-option value="2">Normal</mat-option>
          </mat-select>
        </mat-form-field> -->
        <div class="btn-position btn-position-order-processing">
          <button mat-flat-button color="accent" class="btn-accent" (click)="onSubmit()">Apply Filter</button>
        </div>
      </div>
      <!-- <div class="menu-card-group" *ngIf="Isexpandcontenthide">
        <div class="menu-card-item">
          <p class="title-text">Number of Batches</p>
          <p class="data-text">
            {{NB}}
            <span class="data-text small-data-text"></span>
          </p>
          <div class="menu-bottom-icon">
            <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
          </div>
        </div>
        <div class="menu-card-item">
          <p class="title-text">Total Estimated Quantity</p>
          <p class="data-text">
            {{TEQ}}
            <span class="data-text small-data-text"></span>
          </p>
          <div class="menu-bottom-icon">
            <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
          </div>
        </div>
        <div class="menu-card-item">
          <p class="title-text">Total Actual Quantity</p>
          <p class="data-text">
            {{TAQ}}
            <span class="data-text small-data-text"></span>
          </p>
          <div class="menu-bottom-icon">
            <img class="img" [src]="menuGreenIconUrl" alt="{{ menuGreenIconUrl }}" />
          </div>
        </div>
      </div> -->
      <section>
        <div class="example-button-row">
          <button type="button" class="btn btn-success" (click)="csvExport()" style="margin-top: 25px;"><img src="assets/images/csv-file-format.png" ></button>
          <button type="button" class="btn btn-success" (click)="excelExport()" style="margin-top: 25px; margin-left: 10px;"><i class="fa fa-file-excel-o icon-white"  aria-hidden="true"></i></button>
          <button *ngIf="Isexpandcontenthide" mat-mini-fab mat-button mat-dialog-close color="accent" pTooltip="Expand Grid" tooltipPosition="top"
          (click)="expand()" style="float: right; margin-top: 20px;">
          <mat-icon>fullscreen</mat-icon>
        </button>
        <button mat-mini-fab mat-button mat-dialog-close color="accent" pTooltip="Collapse Grid" tooltipPosition="top" (click)="close()" *ngIf="Isexpandcontentbuttonshow"  style="float: right; margin-top: 20px;">
          <mat-icon>fullscreen_exit</mat-icon>
        </button>
        </div>
      </section>
        <mat-card-content>
          <!-- <ag-grid-angular style="width: 100%; height: 24vw;margin-top: 10px;" class="ag-theme-alpine" [rowData]="rowData"
            [columnDefs]="columnDefs" (gridReady)="onGridReady($event)"  [frameworkComponents]="frameworkComponents"
             [gridOptions]="gridOptions" [pagination]="true" [paginationPageSize]="50">
          </ag-grid-angular> -->
          <ag-grid-angular #agGrid style="width: 100%; height: 40vw" id="myGrid" class="ag-theme-alpine"
          [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [masterDetail]="true" [defaultExportParams]="defaultExportParams"  [excelStyles]="excelStyles"
          [detailCellRendererParams]="detailCellRendererParams" [rowData]="rowData"  [animateRows]="true"
          (firstDataRendered)="onFirstDataRendered($event)" (gridReady)="onGridReady($event)"  [gridOptions]="gridOptions" [pagination]="true" [paginationPageSize]="50">
      </ag-grid-angular>
        </mat-card-content>    
      
    </div>
  </form>
</div>
<ng-template #batchViewModal>
  <div class="viewChecklist">
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>Batch History View</h2>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <div class="content-row-flex-both-end">
      <!--table-->
      <table mat-table class="basic-table plant-model-table" [dataSource]="batchReportViewDatasource" matSort>
        <!-- Item Type Column -->
        <ng-container matColumnDef="itemtype">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">Item</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.ItemCode}}</td>
        </ng-container>

        <ng-container matColumnDef="itemDesc">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">Item Description</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.ItemDesc}}</td>
        </ng-container>
        <ng-container matColumnDef="itemuom">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">Item UOM</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.UOM}}</td>
        </ng-container>

        <!-- Batch Column -->
        <ng-container matColumnDef="estQty">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">Estimated Qty</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.EsimatedQty}}</td>
        </ng-container>

        <!-- length Column -->
        <ng-container matColumnDef="actQty">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">Act Qty </p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.ItemBOMValue}}</td>
        </ng-container>

        <ng-container matColumnDef="supplier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">Supplier</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.Supplier}}</td>
        </ng-container>
        <ng-container matColumnDef="prodDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">Production date</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.ProductionDate}}</td>
        </ng-container>
        <ng-container matColumnDef="expireDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">Expire date</p>
          </th>
          <td mat-cell *matCellDef="let element">{{element.ExpireDate}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="batchViewColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: batchViewColumns"></tr>
        <tr class="mat-row" *matNoDataRow style="text-align: center;">
          <td class="mat-cell" colspan="8">No data Found</td>
        </tr>
      </table>
    </div>
  </div>
</ng-template>